import { Component } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';
import { SignTitleAdjustment } from 'src/app/model/sign/title/sign-title-adjustment';
import { SignTitleAdjustmentOverview } from 'src/app/model/sign/title/sign-title-adjustment-overview';
import { SignTitleAdjustmentControllerRequestService } from 'src/app/services/api/sign-associations/implementations/sign-title-adjustment-controller-request.service';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { AssociationOption } from '../helper/interfaces/association-option';
import { IPBoardAssociationPickerComponent } from '../ip-board-association-picker.component';
import IPBoardPart from '../../../../../../model/product/ip-board/ip-board-part';

@Component({
  selector: 'ip-board-title-picker',
  templateUrl: '../ip-board-association-picker.component.html',
  styleUrls: ['../ip-board-association-picker.component.scss']
})
export class IPBoardTitlePickerComponent extends IPBoardAssociationPickerComponent<
  SignTitleAdjustmentOverview
> {
  constructor(
    protected signTitleAdjustmentControllerRequestService: SignTitleAdjustmentControllerRequestService,
    protected projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super(
      signTitleAdjustmentControllerRequestService,
      projectDisplayObservableService,
      'Titel',
      'Gewenste titel',
      'andere titel',
      true,
      true,
      true,
      true,
      'previousTitleContent',
      'previousOtherSideTitleContent'
    );
  }

  protected initializeAssociationOption(
    option: SignTitleAdjustmentOverview
  ): AssociationOption<SignTitleAdjustmentOverview> {
    return {
      label: option.title,
      representsDefaultOption: false,
      value: option
    };
  }

  protected initializeDefaultOption(
    ipBoardPart: IPBoardPart
  ): AssociationOption<SignTitleAdjustmentOverview> {
    return ipBoardPart.sign == null
      ? null
      : {
          label: ipBoardPart.sign.title,
          representsDefaultOption: true,
          value: null
        };
  }

  protected initializeOtherValue(): string {
    return this.ipBoardPart.otherTitle;
  }

  protected initializeOtherSideOtherValue(): string {
    return this.ipBoardPart.otherSideOtherTitle;
  }

  protected getCurrentSelectedOption(
    ipBoardPart: IPBoardPart
  ): SignTitleAdjustmentOverview {
    return ipBoardPart.titleAdjustment;
  }

  protected getCurrentSelectedOtherSideOption(): SignTitleAdjustmentOverview {
    return this.ipBoardPart.otherTitleAdjustment;
  }

  protected getOtherOptionLabel(): string {
    return 'Andere titel';
  }

  protected wasDefaultOptionSelected(ipBoardPart: IPBoardPart): boolean {
    return (
      ipBoardPart.sign != null &&
      ipBoardPart.titleAdjustment == null &&
      StringHelper.isEmpty(ipBoardPart.otherTitle)
    );
  }

  protected wasOtherSideDefaultOptionSelected(): boolean {
    return (
      this.ipBoardPart.sign != null &&
      this.ipBoardPart.otherTitleAdjustment == null &&
      StringHelper.isEmpty(this.ipBoardPart.otherSideOtherTitle)
    );
  }

  protected wasOtherOptionSelected(): boolean {
    return (
      this.ipBoardPart.sign == null ||
      (this.ipBoardPart.titleAdjustment == null &&
        !StringHelper.isEmpty(this.ipBoardPart.otherTitle))
    );
  }

  protected otherOptionHasValue(): boolean {
    return (
      this.ipBoardPart.titleAdjustment == null &&
      !StringHelper.isEmpty(this.ipBoardPart.otherTitle)
    );
  }

  protected getOtherOptionValue(): string {
    return this.ipBoardPart.otherTitle;
  }

  protected wasOtherSideOtherOptionSelected(): boolean {
    return (
      this.ipBoardPart.sign == null ||
      (this.ipBoardPart.otherTitleAdjustment == null &&
        !StringHelper.isEmpty(this.ipBoardPart.otherSideOtherTitle))
    );
  }

  protected otherSideOtherOptionHasValue(): boolean {
    return (
      this.ipBoardPart.otherTitleAdjustment == null &&
      !StringHelper.isEmpty(this.ipBoardPart.otherSideOtherTitle)
    );
  }

  protected getOtherSideOtherOptionValue(): string {
    return this.ipBoardPart.otherSideOtherTitle;
  }

  protected evaluateShowOtherSidePicker(): boolean {
    return (
      this.selectedOption !== this.otherSideSelectedOption ||
      ((!StringHelper.isEmpty(this.ipBoardPart.otherTitle) ||
        !StringHelper.isEmpty(this.ipBoardPart.otherSideOtherTitle)) &&
        this.ipBoardPart.otherTitle !== this.ipBoardPart.otherSideOtherTitle)
    );
  }

  protected doSetOptionValue(value: SignTitleAdjustmentOverview): void {
    this.ipBoardPart.titleAdjustment = <SignTitleAdjustment>value;
  }

  protected doSetOtherValue(): void {
    this.ipBoardPart.otherTitle = this.otherValue;
  }

  protected doSetOtherOptionValue(value: SignTitleAdjustmentOverview): void {
    this.ipBoardPart.otherTitleAdjustment = <SignTitleAdjustment>value;
  }

  protected doSetOtherSideOtherValue(): void {
    this.ipBoardPart.otherSideOtherTitle = this.otherSideOtherValue;
  }

  protected resetOtherSide(): void {
    this.ipBoardPart.otherTitleAdjustment = this.ipBoardPart.titleAdjustment;
    this.ipBoardPart.otherSideOtherTitle = this.ipBoardPart.otherTitle;
  }

  protected getDefaultTextFromSign(): string {
    return this.ipBoardPart.sign.title;
  }

  protected getTextFromOption(option: SignTitleAdjustmentOverview): string {
    return option.title;
  }

  protected alwaysRememberPreviousValues(): boolean {
    return false;
  }
}
